import { render, staticRenderFns } from "./UserTree.vue?vue&type=template&id=5b61bf4e&scoped=true"
import script from "./UserTree.vue?vue&type=script&lang=js"
export * from "./UserTree.vue?vue&type=script&lang=js"
import style0 from "./UserTree.vue?vue&type=style&index=0&id=5b61bf4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61bf4e",
  null
  
)

export default component.exports